import { render, staticRenderFns } from "./PackageHistoryModal.vue?vue&type=template&id=dca2a1de&scoped=true&lang=pug"
import script from "./PackageHistoryModal.vue?vue&type=script&lang=js"
export * from "./PackageHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./PackageHistoryModal.vue?vue&type=style&index=0&id=dca2a1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca2a1de",
  null
  
)

export default component.exports